module.exports = __webpack_public_path__ + "static/media/allergen_molluscs.87a884ef.87a884ef.png";